const doc = [({"zh_tw":({"adminLabelHotelFilter":({"filterName":"篩選條件名稱", "masterFilterId":"篩選條件", "type":"類型"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;